import styled from 'styled-components'

const UserDetailsStyles = styled.section`
	.userDetailsContainer {
		width: calc(100% - 210px);
		margin-left: 210px;
		background: #f7f7f7;
		min-height: 100vh;
		overflow-x: hidden;
	}
	.userDetailsContent {
		padding: 0 30px 30px 30px;
	}
`

export default UserDetailsStyles
